import { getSubscriptionCards } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useSubscriptionCards = () => {
  const user = useUser();
  const today = useToday();

  return useMemo(
    () => getSubscriptionCards(user?.subscriptions, today),
    [user?.subscriptions, today],
  );
};
